import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerService } from '../../../core/services/customer.service';

@Component({
  selector: 'app-single-view-customer-popup',
  templateUrl: './single-view-customer-popup.component.html',
  styleUrls: ['./single-view-customer-popup.component.scss'],
})
export class SingleViewCustomerPopupComponent implements OnInit {
  @Output() viewCustomerOnchange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible: boolean = false;
  @Input() customerData: any;

  constructor() {}

  ngOnInit(): void {}

  handleCancel(): void {
    this.isVisible = false;
    this.viewCustomerOnchange.emit({
      name: 'isVisible',
      value: false,
    });
  }
}
